import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Query } from 'utility-ts-orm';
import { IPronounsData, IPronounsListDatasource } from '../datasources/pronouns_list_datasource';
import { NO_PRONOUNS_STRING } from '../main';

interface IPronounsListEntry {
  value: string;
  title: string;
}

const defaultPronoun: IPronounsListEntry = {
  value: '',
  title: NO_PRONOUNS_STRING
};

export class PronounsListQuery implements IQuery {
  private _result: IPronounsListEntry[];

  constructor(private ngPronounsListDatasource: IPronounsListDatasource) {
    Query.registerQuery(this, ngPronounsListDatasource);
  }

  run(): PronounsListQuery {
    this._result = [
      {
        value: '',
        title: NO_PRONOUNS_STRING
      }
    ];
    const pronunsList = this.ngPronounsListDatasource.read();
    _4.map(pronunsList, (pronoun: IPronounsData) => {
      if (pronoun.is_active && !pronoun.is_custom) {
        this._result.push({
          value: pronoun.title,
          title: pronoun.title
        });
      }
    });
    this._result.push({
      value: 'custom',
      title: 'Custom'
    });
    return this;
  }

  get result() {
    return this._result;
  }

  isPronounsCustom(pronouns: string): boolean {
    if (_4.isEmpty(pronouns)) {
      return false;
    }
    return !_4.includes(_4.map(this._result, 'title'), pronouns);
  }
}

angular.module('capability-ng-settings').service('ngPronounsListQuery', PronounsListQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-settings/src/queries/pronouns_list_query.ts